module.exports = __webpack_public_path__ + "img/pach_no.9fb0a1c1.png";